// extracted by mini-css-extract-plugin
module.exports = {"button":"button-3Wr1-","minus":"minus-2QKtb","plus":"plus-t4g8E"};